import React from "react";
import styled from "styled-components";
import { FontFamily, FontWeight } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import Tooltip from "@ui-kit/tooltip";
import { ClauseLabels } from "@radarly/models/clause/label";
import ClauseLabelsVerticalRecap from "./vertical-recap";

interface IRootProps {
  title: string;
  clausesLabels: ClauseLabels[];
  locale: Locale;
  warning?: string;
}

type IProps = IRootProps & {
  disabled?: boolean;
  children: React.ReactNode;
};

const Root = styled.div`
  max-width: 288px;
  font-family: ${FontFamily.Sans};
  font-size: 14px;
`;

const VerticalRecap = styled(ClauseLabelsVerticalRecap)`
  font-weight: ${FontWeight.Normal};
`;

export function TooltipContent({
  title,
  clausesLabels,
  warning,
  locale,
}: IRootProps) {
  return (
    <Root>
      {warning && <div>{warning}</div>}
      <div>{title}:</div>
      {clausesLabels.length > 0 && (
        <VerticalRecap clausesLabels={clausesLabels} locale={locale} />
      )}
    </Root>
  );
}

export default function RadarlyComponentsClauseLabelsTooltip({
  disabled,
  children,
  ...props
}: IProps) {
  return (
    <Tooltip disabled={disabled} tooltip={<TooltipContent {...props} />}>
      {children}
    </Tooltip>
  );
}
